import { useEffect, useState } from 'react';
import { sdk } from 'src/utilities/sdk';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import {
  apiPdfStatusToClientPdfStatusMap,
  PDFGenerationApiStatus,
  PDFGenerationStatus,
} from 'src/components/selfService/features/OrderHistory/OrderHistory.utils';

interface IUseOrderReceiptPdfDetails {
  status: PDFGenerationStatus;
  pdfUrl: string;
}

interface IUseOrderReceiptPdfDetailsProps {
  corpId: string;
  orderId: string;
}

export interface IPdfOrderDetialsResponse {
  object?: {
    status: PDFGenerationApiStatus;
    pdf_url: string;
  };
  status: PDFGenerationApiStatus;
}

export function useOrderReceiptPdfDetails({
  corpId,
  orderId,
}: IUseOrderReceiptPdfDetailsProps): IUseOrderReceiptPdfDetails {
  const [pdfOrderDetails, setPdfOrderDetails] =
    useState<IUseOrderReceiptPdfDetails>({
      status: PDFGenerationStatus.IDLE,
      pdfUrl: null,
    });

  const getPdfOrderDetails = async () => {
    try {
      const response: IPdfOrderDetialsResponse = await sdk.http.get(
        `/corp-admin/${corpId}/orders/${orderId}/receipt/pdf`
      );

      // the server can respond with 2 different object structures.
      // for the status NOT_FOUND it will not have the 'object', it will be directly on 'status'
      const status: PDFGenerationApiStatus =
        response?.object?.status || response?.status;
      const pdfUrl = response?.object?.pdf_url;

      setPdfOrderDetails({
        status: apiPdfStatusToClientPdfStatusMap.get(status),
        pdfUrl,
      });
    } catch (error) {
      pushErrorFromAPI(error);
    }
  };

  useEffect(() => {
    getPdfOrderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return pdfOrderDetails;
}
